module.exports = "/assets/cola-page/photo@2x.png?HU62qUT";